import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ModalComponent } from '../../../modal/modal.component';

import { SubmissionRecordObject } from '../../../shared/services/submission-history-object';
import { SubmissionHistoryService } from '../../../shared/services/submission-history.service';
import { SampleSearchRecordObject } from '../../../shared/services/submission-history-object';
import { ErrorDetails} from '../errors/errordetails';
import { SubmissionSearchUserInfoObject} from '../search-object';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';


@Component({
    selector: 'submission-details-table',
    templateUrl: './submission-details-table.component.html',
    styleUrls: [ './submission-details-table.component.scss' ]
})
export class SubmissionDetailsTableComponent implements OnInit, OnDestroy {

    @ViewChild('errorDialog')
    private modalSampleErrors: ModalComponent;

    activeFileRecord: SubmissionRecordObject;
    activeFileRecordList: SampleSearchRecordObject[] = new Array<SampleSearchRecordObject>();
    userInfo: SubmissionSearchUserInfoObject = new SubmissionSearchUserInfoObject();

    errorModalTitle: string;
    errorDetails: ErrorDetails[] = new Array<ErrorDetails>();
    modalSampleId: string;
    btnTrigger: any;

    private sampleSubmissionDataSubscription: Subscription;
    private sampleTableSubscription: Subscription;
    private errorDetailsSubscription: Subscription;
    private     userInfoSubscription: Subscription;

    @ViewChild('sampleSource')
    private modalSubmissionSource: ModalComponent;


    @ViewChild('sampleFhirSource')
    private modalFhirSampleSource: ModalComponent;


    sourceModalTitle: string;
    sourceModalContent: string;


    constructor(private submissionHistoryService: SubmissionHistoryService,
                private route: ActivatedRoute,
                private matIconRegistry: MatIconRegistry,
                private domSanitizer: DomSanitizer) {
        this.route.params.subscribe(res => this.updateTableData(res.id));
        this.matIconRegistry.addSvgIcon(`fhir`, this.domSanitizer
            .bypassSecurityTrustResourceUrl(`images/fhir_trademark_transparent.svg`)
      );
    }

    ngOnInit() {
        this.sampleSubmissionDataSubscription = this.submissionHistoryService.currentSampleSubmissionData
            .subscribe(message => this.activeFileRecord = message);
        this.sampleTableSubscription = this.submissionHistoryService.currentSampleTable
            .subscribe(message => this.activeFileRecordList = message);
        this.userInfoSubscription = this.submissionHistoryService.currentUserInfo
            .subscribe(message => this.userInfo = message);
        // Subscribe to submission errors
        this.errorDetailsSubscription = this.submissionHistoryService.currentSampleErrorDetails.subscribe(errors => {
            this.errorDetails = errors;
            if (errors !== null) {
                this.errorModalTitle = 'Error Message(s) for selected sample';
            } else {
                this.errorModalTitle = '';
            }
        });
    }

    ngOnDestroy() {
        this.sampleSubmissionDataSubscription.unsubscribe();
        this.sampleTableSubscription.unsubscribe();
        this.errorDetailsSubscription.unsubscribe();
        this.userInfoSubscription.unsubscribe();
        this.submissionHistoryService.clearSampleTable();
    }

    review(checked: boolean, id: any, sampleId: any) {
        this.submissionHistoryService.sampleSearchReview(checked, id, sampleId).then(result =>  {
        if (result) {
        }});
    }

    public updateTableData(id: any): void {
        this.submissionHistoryService.getSampleTableContent(id);
    }


    public displaySourceDialog(uuid: string, sampleId: string): void {
        // Step 1: Temporarily clear the title and content areas of the dialog so that a previous
        // sample's contents don't get displayed.
        // TODO: In a future story, replace this with a loading spinner.
        this.sourceModalTitle = 'Loading sample source...';
        this.sourceModalContent = '\n\n\n\n\n\n\n';

        // Step 2: Load the actual content
        const title = 'HML Preview Sample ID ' + sampleId;
        this.submissionHistoryService
            .getSampleSource(uuid, sampleId)
            .then(response =>  {
                if (response) {
                    this.sourceModalTitle = title;
                    this.sourceModalContent = response;
                }
            });
        this.modalSubmissionSource.open();
    }

    copyMessage(e: any, val: string) {
      if (this.btnTrigger) {
        (this.btnTrigger as HTMLElement).classList.remove('down');
      }
      this.btnTrigger = e.target;
      if (this.btnTrigger instanceof HTMLElement) {
        (this.btnTrigger as HTMLElement).classList.add('down');
      }
      navigator.clipboard.writeText(val);
    }

    public displayFhirSourceDialog(uuid: string, sampleId: string): void {
        // Step 1: Temporarily clear the title and content areas of the dialog so that a previous
        // sample's contents don't get displayed.
        // TODO: In a future story, replace this with a loading spinner.
        this.sourceModalTitle = 'Loading sample source...';
        this.sourceModalContent = '\n\n\n\n\n\n\n';

        // Step 2: Load the actual content
        const title = 'HL7 FHIR Sample ID ' + sampleId;
        this.submissionHistoryService
            .getFhirSampleSource(uuid, sampleId)
            .then(response =>  {
                if (response) {
                    this.sourceModalTitle = title;
                    this.sourceModalContent = JSON.parse(response);
                }
            });
        this.modalFhirSampleSource.open();
    }

    public displayAntibodySourceDialog(uuid: string, sampleId: string): void {
        // Step 1: Temporarily clear the title and content areas of the dialog so that a previous
        // sample's contents don't get displayed.
        // TODO: In a future story, replace this with a loading spinner.
        this.sourceModalTitle = 'Loading sample source...';
        this.sourceModalContent = '\n\n\n\n\n\n\n';

        // Step 2: Load the actual content
        const title = 'Antibody Submission ' + sampleId;
        this.submissionHistoryService
            .getSampleSource(uuid, sampleId)
            .then(response =>  {
                if (response) {
                    this.sourceModalTitle = title;
                    this.sourceModalContent = JSON.stringify(JSON.parse(response), null, 2);
                }
            });
        this.modalSubmissionSource.open();
    }

    public displaySrchErrorDialog(uuid: string, sampleId: string): void {
        this.modalSampleId = sampleId;
        this.errorModalTitle = 'Error Message(s) for sample id ' + sampleId;
        this.errorDetails = [];

        this.submissionHistoryService.getSampleErrors(uuid, sampleId); // Subscribed to Observable ErrorDetails in service
        this.modalSampleErrors.open();
    }

    extract(uuid: string) {
        this.submissionHistoryService.getSubmissionSamplesExportContent(uuid);
    }
}
